// UI texts: encounter
export default {
  title: 'Survivor encounter',
  /** How the paths crossed (D2). */
  source: {
    tracks: 'Found by tracking',
    tracksTip: 'You picked up the tracks of {name}. They are not here: this plays out against what they left behind.',
    meet: 'Face to face',
    meetTip: 'You and {name} walked into each other. Both of you decide.',
  },
  sec: 'sec',
  ghostNote: "An echo of a real survivor. {name} passed through here earlier; this plays out against their saved stats and gear. They'll read about it when they log in.",
  npcNote: 'Fresh tracks. {name} passed through here earlier; this plays out against the stats and gear they left behind.',
  lvBg: 'LV {n} · {bg}',
  lvRankBg: 'LV {n} · RANK {rank} · {bg}',
  oppStance: 'Stance: {stance}',
  visibleGear: 'Visible gear',
  gearChip: '{name} · {rarity}',
  gearHidden: '{slot}: cannot be seen (fog, Nightstalker gear or a perk)',
  gearEmpty: '{slot}: nothing',
  estPower: 'Est. power',
  /** Wildsight / Hunter 5 (krug 5, F10). */
  power: 'Power',
  cargo: 'Cargo value: {n}',
  /** Power gap and what it means, while the choice is open (D3). */
  risk3: { stronger: '~{n}% stronger', weaker: '~{n}% weaker', even: 'About even' },
  advice: {
    'much weaker': 'a fight should be easy',
    weaker: 'you have the edge in a fight',
    similar: 'a fight could go either way',
    stronger: 'fighting is risky, following is safer',
    'much stronger': 'fighting is very risky, escaping is safer',
  },
  /** Why the fight estimate disagrees with Power (26. 9. 2026). */
  why: {
    hp: 'you are at {n}% HP',
    theirGear: 'their gear suits this fight',
    yourGear: 'your gear suits this fight',
  },
  youHp: '{power} · {n}% HP',
  you: 'You',
  strength: {
    'much weaker': 'Much weaker than you',
    weaker: 'Weaker than you',
    similar: 'About your strength',
    stronger: 'Stronger than you',
    'much stronger': 'Much stronger than you',
  },
  action: { trade: 'Trade', attack: 'Attack', steal: 'Steal', escape: 'Escape', follow: 'Follow' },
  risk: { 1: 'Low risk', 2: 'Med risk', 3: 'High risk' },
  /** 12. 10. 2026 (owner): what the two numbers on every action mean. */
  legend: "Success: how likely it works. Risk: what it costs you if it doesn't.",
  success: 'success',
  /** Krug 5 (K4.15): a protected survivor cannot be attacked or robbed. */
  locked: 'Locked',
  stanceNote: "If you don't choose, your stance ({stance}) decides:",
  /** What the stance will do, with the chance shown on that action (26. 9. 2026). */
  stanceWill: '{action} · ~{n}%',
  stanceWillLocked: '{action} (they are protected)',
  /** Only Attack and Escape really get the bonus for choosing by hand (krug 3, T4). */
  bonus: 'Attack or Escape by hand: +10%',
  pick: 'Pick an action',
  commit: 'Commit {action} · {n}%',
  later: 'Later',
  minimize: 'Minimize. You can reopen it from camp until the timer runs out.',
  orderSent: 'Order sent: {action}',
  stanceDecided: '{stance} decided: {action}',
  waiting: 'Waiting for the other survivor to decide…',
  resolved: 'It played out. Your survivor keeps going.',
  read: 'Read what happened',
  screen: {
    live: 'Encounter in progress',
    liveBody: '{name} crossed your path in {zone}. Decide before the timer runs out, or your stance decides.',
    open: 'Open the encounter',
    over: 'This encounter is over',
    overBody: 'It was decided without you: your stance made the call. The report has the details.',
    overChosen: 'You gave the order: {action}. The report has the details.',
    notFound: 'This encounter does not exist, or it belongs to another survivor.',
    camp: 'Back to camp',
  },
} as const;
